module.exports = __webpack_public_path__ + "static/img/0.9e4fd02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/0.png
// module id = NGc4
// module chunks = 37